import { A } from '@adornis/base/env-info.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Arg, Entity, Field, Query } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { constructValue } from '@adornis/baseql/entities/construct.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { DateTime } from 'luxon';

@Entity()
export class StudentReport extends AdornisEntity {
  public static override _class = 'StudentReport';

  static override resolveID(entity: any): string {
    return A.getGloballyUniqueID();
  }

  @Field(() => String, {
    default: v => v ?? '',
  })
  public userID?: string;

  @Field(() => Int, {
    default: v => v ?? 0,
  })
  public excused?: number;

  @Field(() => Int, {
    default: v => v ?? 0,
  })
  public missing?: number;

  @Field(() => Int, {
    default: v => v ?? 0,
  })
  public present?: number;
}

/**
 * @entity StudentsReport
 */
@Entity()
export class StudentsReport extends MongoEntity {
  public static override _class = 'StudentsReport';
  public static override _collectionName = 'students-report';

  constructor(doc: PartialEntityData<StudentsReport>) {
    super(doc);
  }

  @Field(() => String, {
    default: v => v ?? '',
  })
  public kpfID?: string;

  @Field(() => DateTime, {
    default: v => v ?? DateTime.now(),
  })
  public updated?: DateTime;

  @Field(() => [StudentReport], {
    default: v => v ?? [],
  })
  public reports?: StudentReport[];

  @Query(() => StudentsReport)
  static getStudentsReportForKPF(@Arg('kpfID', () => String) kpfID: string) {
    return async (gqlFields: BaseQLSelectionSet<StudentsReport>) => {
      const collection = await getCollection(StudentsReport._class);
      const record = (await collection.findOne({
        kpfID,
      })) as StudentsReport | null;

      if (!record) {
        return new StudentsReport({
          kpfID,
          reports: [],
        });
      }

      return constructValue(record) as StudentsReport;
    };
  }
}
